<template>
  <v-card class="text-xs-center">
    <v-btn
      icon
      style="position: absolute; left: 10px; top: 0px"
      v-if="componentId == 'productApproveTable'"
      @click="componentId = 'SelectStore'"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <h1 class="pa-3">
      MERCHANT PRODUCT APPROVE
      <v-btn icon @click="initial()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </h1>
    <div v-if="componentId == 'SelectStore' && isLoadingProvince == false">
      <span v-for="(info, index) in count_product_approve" :key="index">
        <v-btn
          flat
          rounded
          :disabled="selectedProvince == info.province"
          @click="selectProvince(info)"
          >{{ info.province }} ( {{ info.count }} )</v-btn
        >
      </span>
    </div>
    <div v-else-if="componentId == 'SelectStore' && isLoadingProvince == true">
      <v-progress-circular
        :size="30"
        color="primary"
        indeterminate
      ></v-progress-circular>
      {{ "Loading data ..." }}
    </div>
    <component
      :selectedProvince="selectedProvince"
      :loading_message="loading_message"
      @setComponentID="componentId = $event"
      :is="componentId"
      @initStore="selectProvince({ province: selectedProvince })"
    ></component>
  </v-card>
</template>

<script>
import productApproveTable from "@/components/back-office/Merchant/ProductApprove/ProductApproveListTable";
import SelectStore from "@/components/back-office/Merchant/ProductApprove/SelectStore";
import { mapState } from "vuex";

export default {
  components: {
    productApproveTable,
    SelectStore,
  },
  data() {
    return {
      selectedProvince: "",
      loading_message: false,
      isLoadingProvince: false,
      componentId: "SelectStore",
    };
  },
  computed: {
    ...mapState({
      count_product_approve: (state) =>
        state.fetchProductApproveBack.count_product_approve,
    }),
  },
  destroyed() {},
  async created() {
    this.initial();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Product approve",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  methods: {
    async initial() {
      await this.fetchDataCount();
      if (this.count_product_approve && this.count_product_approve.length > 0) {
        this.selectedProvince = this.count_product_approve[0].province;
      }
      this.selectProvince({ province: this.selectedProvince });
    },
    async fetchDataCount() {
      this.isLoadingProvince = true;
      await this.$store.dispatch(
        "fetchProductApproveBack/getProductApproveCount"
      );
      this.isLoadingProvince = false;
    },
    async fetchDataList(province) {
      await this.$store.dispatch(
        "fetchProductApproveBack/getProductEditByProvince",
        this.selectedProvince
      );
    },
    async selectProvince(info) {
      this.selectedProvince = info.province;
      this.loading_message = true;
      await this.fetchDataList(info.province);
      this.loading_message = false;
    },
  },
};
</script>

<style>
</style>
